import Box from "@mui/material/Box";

export type Limos4OfferButtonOption = {
  code: string;
  label: string;
};

interface Limos4OfferButtonsProps {
  options: Limos4OfferButtonOption[];
  selectedCode: string | null | undefined;
  onSelect: (code: string) => void;
}

export default function Limos4OfferButtons({ options, selectedCode, onSelect }: Limos4OfferButtonsProps) {
  if (!options.length) {
    return null;
  }

  return (
    <Box
      className="limos4-offer-buttons"
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "stretch",
        gap: 1,
        width: "100%"
      }}
    >
      {options.map(option => {
        const isActive = option.code === selectedCode;

        return (
          <Box
            key={option.code}
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 0" },
              minWidth: { xs: "100%", sm: 90, md: 100 },
              maxWidth: { sm: options.length === 1 ? 220 : options.length === 2 ? 160 : 140 }
            }}
          >
            <Box
              component="button"
              type="button"
              title={option.label}
              className={`limos4-offer-buttons__item${isActive ? " limos4-offer-buttons__item--active" : ""}`}
              onClick={() => onSelect(option.code)}
              data-cy={`limos4-offer-${option.code}`}
            >
              <span className="limos4-offer-buttons__label">{option.label}</span>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
